



























import {Component, Vue, Prop} from 'vue-property-decorator'

/**
 * We should use this component top of Page component to apply same page style
 * example
 * <template>
 *   <k-page>
 *     <!-- any others -->
 *   </k-page>
 * </template>
 */
@Component
export default class KPage extends Vue {
  @Prop({default: false, type: Boolean}) loading

  get pageClass() {
    return {
      loading: this.loading,
    }
  }
}
